import NextLink from 'next/link';
import { createNavigation } from 'next-intl/navigation';
import { defineRouting } from 'next-intl/routing';

import { DEFAULT_LOCALE, locales } from '@northladder/utilities';

/**
 * We'll integrate with Next.js' routing in two places:
 * Middleware: Negotiates the locale and handles redirects & rewrites (e.g. / → /en)
 * Navigation APIs: Lightweight wrappers around Next.js' navigation APIs like <Link />
 * This enables you to work with pathnames like /about, while i18n aspects like
 * language prefixes are handled behind the scenes.
 *
 * To share the configuration between these two places, we'll set up routing.ts:
 * - https://next-intl-docs.vercel.app/docs/getting-started/app-router/with-i18n-routing#i18n-routing
 * - https://next-intl.dev/docs/getting-started/app-router/with-i18n-routing
 * NOTE: On migrations https://next-intl.dev/blog/next-intl-3-22#create-navigation
 */
export const routing = defineRouting({
  // A list of all locales that are supported
  locales,

  // Used when no locale matches - en is the default
  defaultLocale: DEFAULT_LOCALE,
});

// Lightweight wrappers around Next.js' navigation APIs
// that will consider the routing configuration
export const { redirect, usePathname, useRouter, getPathname } =
  createNavigation(routing);

/**
 * The main wrapper around Next.js' Link component that injects the locale if
 * the current locale is not the default one.
 */
export const Link = createNavigation(routing).Link as typeof NextLink;

export type { LinkProps } from 'next/link';
